import React from 'react';
import { useSelector } from 'react-redux';

import { CallStatus } from '../../lib/enums';
import { CompanyLogoAndNameState } from '../../lib/models/fundamental/types';
import { RootState } from '../../lib/store';
import { TypedObject } from '../../lib/util/types';

import CompanyLogoCheckmark from '../CompanyLogoCheckmark/CompanyLogoCheckmark';

import styles from './ProcessFinishedModal.module.scss';

type Props = {
    symbol: string;
    processFailedMessage: string;
    processFailedMessageSub?: string;
    processSuccessMessageTitle: string;
    callStatus?: CallStatus;
    defaultMessageBody?: string;
    defaultMessageTitle?: string;
    processPendingMessage?: { title: string, body: string };
    processPartiallyRejectedMessage?: { title: string, body: string };
    processSuccessMessageBody?: string;
}

const ModalBody = ({
  symbol,
  callStatus,
  defaultMessageBody,
  processFailedMessage,
  processFailedMessageSub,
  defaultMessageTitle,
  processPendingMessage,
  processSuccessMessageBody,
  processSuccessMessageTitle,
  processPartiallyRejectedMessage,
} : Props) => {
  const companyLogoAndName = useSelector<RootState, TypedObject<CompanyLogoAndNameState>>(
    (state: RootState) => state.fundamental.companyLogoAndName,
  );
  const logo = companyLogoAndName[symbol]?.logo;
  const url = companyLogoAndName[symbol]?.url;

  const errorMessageRender = () => {
    if (processPartiallyRejectedMessage) {
      return (
        <>
          <h6 className={styles.title}>{processPartiallyRejectedMessage.title}</h6>
          <p className={styles.message}>{processPartiallyRejectedMessage.body}</p>
        </>
      );
    }

    return (
      <>
        <h6 className={styles.errorTitle}>{processFailedMessage}</h6>
        {processFailedMessageSub && <h6 className={styles.errorTitle}>{processFailedMessageSub}</h6>}
      </>
    );
  };
  const getModalBody = (): JSX.Element => {
    if (callStatus === CallStatus.READY) {
      return (
        <>
          <CompanyLogoCheckmark url={url} logo={logo} symbol={symbol} />
          <h6 className={styles.title}>{processSuccessMessageTitle}</h6>
          {processSuccessMessageBody && <p className={styles.message}>{processSuccessMessageBody}</p>}
        </>
      );
    }
    if (processPendingMessage) {
      return (
        <>
          <CompanyLogoCheckmark url={url} logo={logo} symbol={symbol} />
          <h6 className={styles.title}>{processPendingMessage.title}</h6>
          <p className={styles.message}>{processPendingMessage.body}</p>
        </>
      );
    }
    if (defaultMessageTitle) {
      return (
        <>
          <CompanyLogoCheckmark url={url} logo={logo} symbol={symbol} />
          <h6 className={styles.title}>{defaultMessageTitle}</h6>
          {defaultMessageBody && <p className={styles.message}>{defaultMessageBody}</p>}
        </>
      );
    }
    return (
      <div className={styles.errorWrapper}>
        <CompanyLogoCheckmark isCancel url={url} logo={logo} symbol={symbol} />
        {errorMessageRender()}
      </div>
    );
  };

  return getModalBody();
};

export default ModalBody;
